;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();import { Card, CardDescription, CardTitle } from '@workspace/ui/components/card';
import { cn } from '@workspace/ui/lib';

interface SelectionCardProps {
  variant?: 'large' | 'small-left-icon' | 'small-center-icon';
  title: string;
  description: string;
  value: string;
  cardIcon?: React.ComponentType<{ className?: string }>;
  onClick?: (value: string) => void;
  disabled?: boolean;
  selectedValue?: string;
}

export const SelectionCard = ({
  title,
  description,
  value,
  cardIcon,
  variant = 'large',
  onClick,
  disabled,
  selectedValue,
}: SelectionCardProps) => {
  const Icon = cardIcon;

  return (
    <Card
      onClick={() => onClick?.(value)}
      disabled={disabled}
      selected={selectedValue === value}
      variant={variant}
    >
      <div
        className={cn(
          variant === 'large' && 'p-4',
          variant === 'small-left-icon' && 'p-0',
          variant === 'small-center-icon' && 'px-2'
        )}
      >
        {Icon && (
          <Icon
            className={cn(
              'text-grey-300 group-aria-disabled:text-grey-300 dark:group-aria-disabled:text-grey-800 group-hover:text-pink-400 group-aria-selected:text-pink-400 dark:text-neutral-100 dark:group-aria-selected:text-pink-300',
              variant === 'large' ? 'h-14 w-14' : 'h-8 w-8'
            )}
          />
        )}
      </div>
      <div
        className={cn(
          'flex flex-col gap-1',
          variant === 'small-left-icon' && 'items-start',
          variant === 'small-center-icon' && 'items-center',
          variant === 'large' && 'items-center'
        )}
      >
        <CardTitle>{title}</CardTitle>
        <CardDescription variant={variant}>{description}</CardDescription>
      </div>
    </Card>
  );
};
